
import { fetchEventsPage } from '@/assets/scripts/api'
import {
  bestPicFormat,
  createNavigationPopinItem,
} from '@/assets/scripts/utils'
import DetailToPopin from '@/mixins/DetailToPopin'
import PageData from '@/mixins/PageData'

export default {
  name: 'EventsPage',
  popinContentComponent: 'DetailEvent',
  mixins: [PageData, DetailToPopin],

  async asyncData({ payload }) {
    if (payload) {
      return { apiData: payload }
    }
    return { apiData: await fetchEventsPage() }
  },

  computed: {
    eventCount() {
      return this.apiData.events.length
    },
  },

  created() {
    this.bestPicFormat = bestPicFormat
  },

  methods: {
    shouldIndexDisplayedWide(index) {
      const mod = index % 5
      return index < this.eventCount - 1
        ? mod === 0
        : mod === 0 || mod === 1 || mod === 3
    },

    getPopinData() {
      const events = this.apiData ? this.apiData.events : []
      return events.find((event) => event.slug === this.$route.params.popin)
    },

    getPopinNavItems() {
      let poster, label, url
      const events = this.apiData ? this.apiData.events : []
      const popinNavItems = events.map((event) => {
        poster = bestPicFormat(event.picSquare, ['small', 'medium', 'origin'])
        label = event.title
        url = '/evenements/' + event.slug
        return createNavigationPopinItem(
          'MediaThumb',
          { props: { poster, label } },
          url
        )
      })
      return popinNavItems
    },
  },
}
